import React, { Component, Fragment } from 'react';
import { AlertBanner } from 'synapsefi-dev-ui';
import styled from 'styled-components';
import ErrorContext from './contexts/ErrorContext';

const AlertContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledAlertBanner = styled(AlertBanner)`
    font-weight: normal;
    width: 100%;
    padding: 8px 20px 0 20px;
    z-index: 1;

    [class^='AlertBanner__Banner'] {
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.20);
    }
`;

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            errStatus: '',
            showAlert: false
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            errorMsg: error,
        });
    }

    renderError = (errorMsg, errStatus) => {
        this.setState({
            errorMsg: errorMsg,
            errStatus: errStatus || 'ERROR',
            showAlert: true
        });
    }

    handleClose = () => {
        this.setState({
            showAlert: false,
            errorMsg: ''
        });
    }

    renderAlert() {
        const { showAlert, errorMsg, errStatus } = this.state;

        return (
            <AlertContainer>
                <StyledAlertBanner
                    type={errStatus}
                    show={showAlert}
                    alertText={errorMsg}
                    handleClose={this.handleClose}
                />
            </AlertContainer>
        )
    }

    render() {
        const { showAlert } = this.state;
        const { children } = this.props;

        return (
            <Fragment>
                <ErrorContext.Provider
                    value={{
                        ...this.state,
                        renderError: this.renderError
                    }}
                >
                    {showAlert && this.renderAlert()}
                    {children}
                </ErrorContext.Provider>
            </Fragment>
        )
    }
}

export default ErrorBoundary;